module.exports = __webpack_public_path__ + "static/media/photo1.e716b299.png";